import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateEventAccountPricesMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  event_id: Types.Scalars['ID'];
  prices: Array<Types.EventPriceInput> | Types.EventPriceInput;
}>;


export type UpdateEventAccountPricesMutation = { __typename?: 'Mutation', updateEventAccountPrices: { __typename?: 'EventAccount', id: string } };


export const UpdateEventAccountPricesDocument = gql`
    mutation UpdateEventAccountPrices($event_account_id: ID!, $event_id: ID!, $prices: [EventPriceInput!]!) {
  updateEventAccountPrices(
    event_account_id: $event_account_id
    event_id: $event_id
    prices: $prices
  ) {
    id
  }
}
    `;
export type UpdateEventAccountPricesMutationFn = Apollo.MutationFunction<UpdateEventAccountPricesMutation, UpdateEventAccountPricesMutationVariables>;

/**
 * __useUpdateEventAccountPricesMutation__
 *
 * To run a mutation, you first call `useUpdateEventAccountPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventAccountPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventAccountPricesMutation, { data, loading, error }] = useUpdateEventAccountPricesMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      event_id: // value for 'event_id'
 *      prices: // value for 'prices'
 *   },
 * });
 */
export function useUpdateEventAccountPricesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventAccountPricesMutation, UpdateEventAccountPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventAccountPricesMutation, UpdateEventAccountPricesMutationVariables>(UpdateEventAccountPricesDocument, options);
      }
export type UpdateEventAccountPricesMutationHookResult = ReturnType<typeof useUpdateEventAccountPricesMutation>;
export type UpdateEventAccountPricesMutationResult = Apollo.MutationResult<UpdateEventAccountPricesMutation>;
export type UpdateEventAccountPricesMutationOptions = Apollo.BaseMutationOptions<UpdateEventAccountPricesMutation, UpdateEventAccountPricesMutationVariables>;